import { render } from "./UsersListTab.vue?vue&type=template&id=0392234b&scoped=true&ts=true"
import script from "./UsersListTab.vue?vue&type=script&lang=ts"
export * from "./UsersListTab.vue?vue&type=script&lang=ts"

import "./UsersListTab.vue?vue&type=style&index=0&id=0392234b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0392234b"]])

export default __exports__